/*
 * ギャラリー：画像クリックで拡大表示（ライトボックス）
 */
(function () {
  function initGallery(gallery) {
    var lightbox = gallery.querySelector('.gallery__lightbox');
    if (!lightbox) return;
    var img = lightbox.querySelector('.gallery__lightbox-img');

    function open(src, alt) {
      img.setAttribute('src', src);
      img.setAttribute('alt', alt || '');
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      img.removeAttribute('src');
      document.body.style.overflow = '';
    }

    gallery.addEventListener('click', function (event) {
      var item = event.target.closest('.gallery__item[data-full]');
      if (!item || lightbox.contains(item)) return;
      event.preventDefault();
      open(item.getAttribute('data-full'), item.getAttribute('data-alt'));
    });

    lightbox.addEventListener('click', function () {
      close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
        close();
      }
    });
  }

  function init(root) {
    var scope = root || document;
    var list = scope.querySelectorAll('[data-gallery]:not([data-gallery-init])');
    Array.prototype.forEach.call(list, function (gallery) {
      gallery.setAttribute('data-gallery-init', '');
      initGallery(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
